module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBoldItalic.70008e33.eot";